import React, { useState, useEffect } from "react";
import { InputText } from "primereact/inputtext";
import { Password } from "primereact/password";
import { Button } from "primereact/button";
import { useNavigate } from "react-router-dom";
import Navbar from "../components/NavBar";

import { loginRequest } from "../services/loginService";
import { setSession, clearSession } from "../services/authService";

export default function Login() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [errorMsg, setErrorMsg] = useState("");
  const [loading, setLoading] = useState(false);

  const navigate = useNavigate();

  useEffect(() => {
    clearSession();
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setErrorMsg("");
    setLoading(true);

    try {
      const data = await loginRequest(email, password);

      if (!data.success) {
        setErrorMsg(
          data.message || "No fue posible iniciar sesión. Verifica tus datos."
        );
        return;
      }

      // Guardamos "sesión" en el front (solo para controlar acceso a Limpiador)
      setSession(data.user || { email });

      // Redirigimos a la ruta protegida
      navigate("/inicio_profesores");
    } catch (err) {
      console.error(err);
      setErrorMsg(
        "Ocurrió un error al conectarse con el servidor. Intenta más tarde."
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ minHeight: "100vh", background: "#f1f3f7" }}>
      {/* Quita esto si NO quieres el menú en la página de login */}
      <Navbar />

      <main
        className="flex justify-content-center align-items-center"
        style={{
          minHeight: "calc(100vh - 64px)",
          padding: "2rem 1rem",
          background:
            "linear-gradient(135deg, rgba(15,59,99,0.06), rgba(242,147,63,0.06))",
        }}
      >
        <div
          className="grid w-full"
          style={{
            maxWidth: 960,
            background: "#ffffff",
            borderRadius: 18,
            boxShadow: "0 18px 45px rgba(15,59,99,.18)",
            overflow: "hidden",
          }}
        >
          {/* Columna izquierda: texto + form */}
          <div
            className="col-12 md:col-12"
            style={{ padding: "2rem 2.5rem 2.5rem" }}
          >
            <div style={{ marginBottom: 18 }}>
              <div
                style={{
                  color: "#F2933F",
                  fontWeight: 800,
                  letterSpacing: ".4px",
                  marginBottom: 4,
                  fontSize: 13,
                }}
              >
                ACCESO PARA PROFESORES
              </div>
              <h2
                style={{
                  margin: 0,
                  color: "#0f3b63",
                  fontWeight: 900,
                  fontSize: "clamp(22px, 3vw, 30px)",
                  lineHeight: 1.2,
                }}
              >
                Inicia sesión en tu cuenta
              </h2>
              <p
                style={{
                  marginTop: 10,
                  marginBottom: 0,
                  color: "#6b7b8d",
                  fontSize: 14,
                  lineHeight: 1.7,
                }}
              >
                Ingresa tus credenciales para acceder a la herramienta para
                profesores de la Licenciatura en Marketing Digital. Si tienes
                problemas, ponte en contacto con el área de soporte.
              </p>
            </div>

            <form onSubmit={handleSubmit}>
              {/* Correo */}
              <div style={{ marginBottom: 14 }}>
                <label
                  htmlFor="email"
                  style={{
                    display: "block",
                    fontWeight: 700,
                    marginBottom: 6,
                    color: "#0f3b63",
                    fontSize: 14,
                  }}
                >
                  Correo electrónico
                </label>
                <InputText
                  id="email"
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  className="w-full"
                  placeholder="correo@ejemplo.com"
                  required
                />
              </div>

              {/* Contraseña */}
              <div style={{ marginBottom: "20px" }}>
                <label
                  htmlFor="password"
                  style={{
                    display: "block",
                    fontWeight: 700,
                    marginBottom: 6,
                    color: "#0f3b63",
                    fontSize: 14,
                  }}
                >
                  Contraseña
                </label>

                <Password
                  id="password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  feedback={false}
                  toggleMask
                  placeholder="••••••••"
                  required
                  className="w-full"
                  inputClassName="w-full"
                  inputStyle={{
                    width: "100%",
                    padding: "0.75rem",
                    fontSize: "1rem",
                    boxSizing: "border-box",
                  }}
                  style={{
                    width: "100%",
                    display: "block",
                    borderRadius: "8px",
                  }}
                  panelStyle={{ display: "none" }}
                />
              </div>

              {/* 
                          {/* Recordarme + Olvidé mi contraseña /}
              <div
                className="flex justify-content-between align-items-center"
                style={{ marginBottom: 18, fontSize: 13 }}
              >
                <label
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: 6,
                    color: "#4a5568",
                    cursor: "pointer",
                  }}
                >
                  <input
                    type="checkbox"
                    checked={remember}
                    onChange={(e) => setRemember(e.target.checked)}
                    style={{ cursor: "pointer" }}
                  />
                  Recordarme en este equipo
                </label>

                <button
                  type="button"
                  style={{
                    border: "none",
                    background: "transparent",
                    color: "#0f3b63",
                    fontWeight: 600,
                    cursor: "pointer",
                    textDecoration: "underline",
                  }}
                  onClick={() => console.log("click recuperar contraseña")}
                >
                  ¿Olvidaste tu contraseña?
                </button>
              </div>
            */}

              {/* Botón de login */}
              <Button
                type="submit"
                label="Ingresar"
                icon="pi pi-sign-in"
                className="w-full"
                style={{
                  background: "#0f3b63",
                  borderColor: "#0f3b63",
                  borderRadius: 12,
                  padding: "0.8rem 1rem",
                  fontWeight: 800,
                  letterSpacing: ".2px",
                }}
              />
            </form>

            {/* Texto inferior */}
            <div
              style={{
                marginTop: 16,
                fontSize: 12,
                color: "#718096",
                lineHeight: 1.7,
              }}
            >
              Si aún no cuentas con usuario y contraseña, solicita tu acceso al
              área de coordinacion de la Licenciatura.
            </div>
          </div>
        </div>
      </main>
    </div>
  );
}
